import { render, staticRenderFns } from "./AppUpdateBanner.vue?vue&type=template&id=6aac415e&scoped=true&"
import script from "./AppUpdateBanner.vue?vue&type=script&lang=ts&"
export * from "./AppUpdateBanner.vue?vue&type=script&lang=ts&"
import style0 from "./AppUpdateBanner.vue?vue&type=style&index=0&id=6aac415e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac415e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VRow})
